module.exports = __webpack_public_path__ + "img/01_MenuBG_alt.c125a917.jpg";